import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { serviceRequestCompletedReducer } from './service-request-completed.reducer';
import {
  SERVICE_REQUEST_COMPLETED,
  ServiceRequestCompletedState,
  ServiceRequestCompletedStore,
} from './service-request-completed.state';

/** Token of the ServiceRequestCompleted reducer */
export const SERVICE_REQUEST_COMPLETED_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<ServiceRequestCompletedStore, Action>
>('Feature ServiceRequestCompleted Reducer');

/** Provide default reducer for ServiceRequestCompleted store */
export function getDefaultServiceRequestCompletedReducer() {
  return serviceRequestCompletedReducer;
}

@NgModule({
  imports: [StoreModule.forFeature(SERVICE_REQUEST_COMPLETED, SERVICE_REQUEST_COMPLETED_REDUCER_TOKEN)],
  providers: [
    {
      provide: SERVICE_REQUEST_COMPLETED_REDUCER_TOKEN,
      useFactory: getDefaultServiceRequestCompletedReducer,
    },
  ],
})
export class ServiceRequestCompletedStoreModule {
  public static forRoot<T extends ServiceRequestCompletedState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<ServiceRequestCompletedStoreModule> {
    return {
      ngModule: ServiceRequestCompletedStoreModule,
      providers: [{ provide: SERVICE_REQUEST_COMPLETED_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
